import React from 'react';
import * as ReactRedux from 'react-redux';

import {resetAllCookieClicks, venditshop} from '../../../index';
import {receiveLoadingUpdate, show_mobile_menu} from '../../../redux/actions';
import Schnellerfassung from '../../element/Schnellerfassung';

import Icon from './Icon';

const Sitehead = (props) => {
  const meta = props?.meta;
  const conf = meta?.conf;
  const anbruch = !!meta?.licenseCache?.anbruch;
  const mobile = props.mobile || false;
  const mobileBig = props.mobileBig || false;


  let slogans = null;
  if (props?.config?.slogans?.length) {
    slogans = props.config.slogans.map(
      (slogan) => <span key={slogan.id} title={slogan.bezeichnung}>
        <i className='icon fas fa-check'/>{slogan.bezeichnung}
      </span>
    );
  }
  const infoArea = <section className='info'>
    {slogans}
  </section>;

  let actionBtn = null;
  let logoutBtn = null;
  if (props.maintenance) {
    actionBtn = <a className='login' rel='nofollow' href='#'>
      <i className='icon fas fa-user'/>Anmelden
    </a>;
  } else {
    if (meta?.login) {
      actionBtn = <a className='login' rel='nofollow' href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/customer/'}>
        <i className='icon fas fa-user'/>Mein Konto
      </a>;
    } else {
      actionBtn = <a className='login' rel='nofollow' href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/login/'}>
        <i className='icon fas fa-user'/>Anmelden
      </a>;
    }
  }

  let cartArea = null;
  let contactAnchor = <a href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/contact/'} className='contact'>
    <i className='icon fas fa-phone'/>Kontakt
  </a>;
  let linkToMainPage = null;
  if (meta?.linkToMainPage) {
    linkToMainPage =
      <a target='_blank' rel='noopener noreferrer' className='linkToMainPage' href={meta.linkToMainPage} onClick={() => {
        props?.changeLoading(true);
        resetAllCookieClicks();
      }}>
        <i className='icon fas fa-info-circle'/>Erfahren Sie mehr über uns
      </a>;
  }

  let schnellerfassung = <Schnellerfassung suche maintenance={props.maintenance}/>;

  const countHeader = conf?.countPosHeader && mobile ? props.countPos : props.count;


  if (props?.hide_interaction) {
    cartArea = null;
    schnellerfassung = null;
  } else if (props.maintenance) {
    cartArea = <a className='checkout' rel='nofollow' href='#' onClick={() => {
      props?.changeLoading(true);
      resetAllCookieClicks();
    }}>
      <i className='icon fas fa-shopping-cart'/>
      <div className='cart'>
        <div className='count'>Warenkorb ({(props.count || 0).toFixed(anbruch ? 2 : 0)})</div>
        <div className='total'>{venditshop.helper.formatCurrency(props.total)}</div>
      </div>
      <i className='icon fas fa-chevron-circle-right'/>
    </a>;
    contactAnchor = <a href='#' className='contact' onClick={() => {
      props?.changeLoading(true);
      resetAllCookieClicks();
    }}>
      <i className='icon fas fa-phone'/>Kontakt
    </a>;
  } else if (meta?.login) {
    if(props?.hausmesse){
      cartArea = <a className='checkout' rel='nofollow' href={'/messecart/'+props?.hausmesse} onClick={() => {
        props?.changeLoading(true);
        resetAllCookieClicks();
      }}>
        <i className='icon fas fa-shopping-cart'/>
        <div className='cart'>
          <div className='count'>Messe-Order ({(props.countMesse || 0).toFixed(anbruch ? 2 : 0)})</div>
          <div className='total'>{venditshop.helper.formatCurrency(props.totalMesse)}</div>
        </div>
        <i className='icon fas fa-chevron-circle-right'/>
      </a>;
    }else{
      //hier ist auch die Vertriebsaktion
      console.log('Warenkorb im Header');
      console.log(meta?.vertriebsaktion);

      let text = 'Warenkorb';
      let link = '/cart/';

      if(meta?.vertriebsaktion){
        text = 'Vertriebsaktion';
        link = '/cart/vertriebsaktion/';
      }

      cartArea = <a className='checkout' rel='nofollow' href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+link} onClick={() => {
        props?.changeLoading(true);
        resetAllCookieClicks();
      }}>
        <i className='icon fas fa-shopping-cart'/>
        <div className='cart'>
          <div className='count'>{text} ({(props.count || 0).toFixed(anbruch ? 2 : 0)})</div>
          <div className='total'>{!meta?.onlyKvpAnzeigen || !conf?.nurKVPKomplett ? venditshop.helper.formatCurrency(props.total): null}</div>
        </div>
        <i className='icon fas fa-chevron-circle-right'/>
      </a>;
    }
    if (conf?.sitehead_logout_button) {
      logoutBtn = <a href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/logout/'} onClick={() => {
        props?.changeLoading(true);
        resetAllCookieClicks();
      }}><i className='icon fas fa-sign-out-alt'/>Abmelden</a>;
    }
  } else {
    cartArea = <a className='checkout' rel='nofollow' href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/cart/'} onClick={() => {
      props?.changeLoading(true);
      resetAllCookieClicks();
    }}>
      <i className='icon fas fa-shopping-cart'/>
      <div className='cart'>
        <div className='count no-total'>Warenkorb ({(countHeader || 0).toFixed(anbruch ? 2 : 0)})</div>
      </div>
      <i className='icon fas fa-chevron-circle-right'/>
    </a>;
  }

  const icon = props.maintenance ? 'wrench' : 'bars';
  if (mobile) {

    let mobileCart = <a href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/cart/'} onClick={() => {
      props?.changeLoading(true);
      resetAllCookieClicks();
    }}><Icon type='shopping-cart'/>
      {countHeader ? <span className='countCart'>{(countHeader || 0).toFixed(anbruch ? 2 : 0)}</span> : null}
    </a>;

    if(props?.hausmesse){
      mobileCart = <a href={'/messecart/'+props?.hausmesse} onClick={() => {
        props?.changeLoading(true);
        resetAllCookieClicks();
      }}><Icon type='shopping-cart'/>
        {countHeader ? <span className='countCart'>{(props.countMesse || 0).toFixed(anbruch ? 2 : 0)}</span> : null}
      </a>;
    }

    return <header className={'_Sitehead '+(props?.hidden ? 'hidden': '')} >
      <div className='upper'>
        <Icon type={icon} onClick={props.show_mobile_menu}/>
        <a className='brand' href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/'} onClick={() => {
          props?.changeLoading(true);
          resetAllCookieClicks();
        }}/>
        <a href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/contact/'} onClick={() => {
          props?.changeLoading(true);
          resetAllCookieClicks();
        }}><Icon type='phone'/></a>
        <a href={meta?.login ? (props?.hasInfo && props?.hasInfo?.gelesen !== props.hasInfo?.infos) ? (props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/customerinfo/' : (props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/customer/' : (props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/login/'}
           onClick={() => {
             props?.changeLoading(true);
             resetAllCookieClicks();
           }}><Icon
          type='user'/>
        {props?.hasInfo && props?.hasInfo?.gelesen !== props.hasInfo?.infos ? <span
          className='infoCount'>{props.hasInfo?.infos - props?.hasInfo?.gelesen}</span> : null}
        </a>
        {mobileCart}
      </div>
      <div className='lower'>
        {schnellerfassung}
      </div>
    </header>;
  }


  return <header className='_Sitehead' >
    <section className='control'>
      <div className='inner'>
        {linkToMainPage}
        {contactAnchor}
        {actionBtn}
        {logoutBtn}
      </div>
    </section>
    <section className='main'>
      <div className='inner'>
        {mobileBig ? <button className='bars' onClick={() => {
          props.show_mobile_menu();
        }}>
          <i className={'icon fas fa-' + icon}/></button> : null}
        <a className='brand' href={(props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/'}/>
        {schnellerfassung}
        {cartArea}
      </div>
    </section>
    {infoArea}
  </header>;
};

export default ReactRedux.connect((state) => ({
  countPos: venditshop.helper.shoppingcartCountPos(state.cart),
  count: venditshop.helper.shoppingcartTotalCount(state.cart),
  total: venditshop.helper.shoppingcartTotalAmount(state.cart),
  countPosMesse: venditshop.helper.shoppingcartCountPos(state.messecart),
  countMesse: venditshop.helper.shoppingcartTotalCount(state.messecart),
  totalMesse: venditshop.helper.shoppingcartTotalAmount(state.messecart),
  meta: state.meta,
  mobile: state.mobile.isMobile,
  mobileBig: state.mobileBig.isBig
}), (dispatch) => ({
  show_mobile_menu: () => dispatch(show_mobile_menu()),
  changeLoading: (loading) => {
    dispatch(receiveLoadingUpdate(loading));
  }
}))(Sitehead);
